import React from "react";
import { Skeleton } from "@mui/material";

const ShimmerLoader = ({ sx }) => {
    return (
        <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{ position: "absolute", top: 0, left: 0, ...sx }}
        />
    );
};

export default ShimmerLoader;
